module.exports = __webpack_public_path__ + "img/u1348.fd708f94.jpg";